var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.252 0.565839C7.32753 0.522694 7.41301 0.5 7.5 0.5C7.58699 0.5 7.67247 0.522694 7.748 0.565839L14.748 4.56584C14.8245 4.60955 14.8881 4.67272 14.9324 4.74893C14.9766 4.82515 15 4.91171 15 4.99984V5.71984C15 7.92581 14.2814 10.0717 12.9528 11.8328C11.6243 13.5938 9.75818 14.8741 7.637 15.4798C7.54745 15.5054 7.45255 15.5054 7.363 15.4798C5.24182 14.8741 3.37571 13.5938 2.04717 11.8328C0.718624 10.0717 -2.74894e-05 7.92581 7.88645e-10 5.71984L7.88644e-10 4.99984C2.84278e-05 4.91171 0.0233513 4.82515 0.0676055 4.74893C0.11186 4.67272 0.175473 4.60955 0.252 4.56584L7.252 0.565839ZM7.072 11.2108L11.39 5.81184L10.61 5.18784L6.928 9.78884L4.32 7.61584L3.68 8.38384L7.072 11.2108Z",
    fill: "#0051B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePassword);
export default __webpack_public_path__ + "static/media/secure-password.2712d899cf63baab6bb253879606d6b8.svg";
export { ForwardRef as ReactComponent };